@if (googleApisScriptInjectorService.isGoogleApiScriptLoaded() | async) {
    <google-map id="google-map" [options]="mapOptions">
        @let selectedCompanyValue = this.selectedCompanyValue();
        @for (marker of points(); track marker; let ix = $index) {
            <map-marker [position]="marker.position" (mapClick)="markerSelected(ix, marker.companyAddressId)" />
            <map-info-window>
                <div class="name">{{ selectedCompanyValue?.name }}</div>
                <div class="address">{{ selectedCompanyValue?.fullAddress }}</div>
                <div class="distance">
                    <warema-svg-icon filePath="shared-assets/icons/location.svg" height="18" width="12" />
                    <div>{{ selectedCompanyValue?.distance }}</div>
                </div>
            </map-info-window>
        }
    </google-map>
}
